import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import CSSModules from 'react-css-modules';
import styles from './product.css';

import { Select, TableHeader, Table, TableRows } from 'components';

import Translate from 'utils/translate';

class Product extends Component {
  constructor(props) {
    super(props);

    const { platforms } = props.product;

    this.state = {
      platform: platforms.length ? platforms[0].value : '',
      allVersions: true,
      fullRelease: platforms.length ? this.getLatestRelease(platforms[0].value) : '',
    };
  }

  selectPlatform(event) {
    this.setState({
      platform: event.target.value,
      allVersions: true,
      fullRelease: this.getLatestRelease(event.target.value),
    });
  }

  getLatestRelease(platform) {
    const { product } = this.props;
    return product.platforms[_.findIndex(product.platforms, { value: platform })].releases[0]
      .release;
  }

  toggleAllVersions() {
    const { allVersions } = this.state;
    this.setState({
      allVersions: !allVersions,
    });
  }

  hasMultipleVersions() {
    let entries = [];
    let hasHiddenEntries = false;
    const { product } = this.props;
    const { platform, fullRelease } = this.state;

    product.cards.forEach(card => {
      if (card.platform === platform && !card.alwaysVisible) {
        entries.push(card);
      }
    });

    entries.forEach(entry => {
      if (entry.release !== fullRelease) {
        hasHiddenEntries = true;
      }
    });

    return hasHiddenEntries;
  }
  
  render() {
    const { product } = this.props;
    const { platform, allVersions, fullRelease } = this.state;
    let columnWidths = [];
    let softwareHeaders = [];
    let patchHeaders = [];
    // The numColumns value determines what columns width are used from columnDimensions. No product has fewer then 3 columns, so the value is offset by 3.
    let numColumns = 0;
    let columnOffset = 3;
    const columnDimensions = [
      ['4%', '35%', '31%', '30%'], // Dimensions for 3 column layout
      ['4%', '31%', '26%', '25%', '12%'], // Dimensions for 4 column layout
      ['4%', '30%', '20%', '17%', '16%', '12%'], // Dimensions for 5 column layout
      ['4%', '27%', '17%', '14%', '13%', '13%', '12%'], // Dimensions for 6 column layout
      ['4%', '27%', '13%', '10%', '10%', '14%', '17%', '12%']  // Dimensions for 7 column layout
    ]

    // The card properties that are used to build the product columns. Default is false until confirmed to exist for the product.
    let checkedHeaders = {
      title: false,
      release: false,
      releaseDate: false,      
      releaseName: false,
      releaseType: false,
      minimumDsmVersionRequired: false,      
      download : false
    };

    // Check each product card for the existence of the properties in checkedHeaders. If the property exists in even just one product card, set the value to 'true'.
    product.cards.forEach (card => {
      for (const header in checkedHeaders) {
        if (card[header]) {
          checkedHeaders[header] = true
        }
      }
    });

    // Create column headers for all properties that were found to exist for the product.
    softwareHeaders = []
    if (checkedHeaders.title) {
      softwareHeaders.push(
        {
          colSpan: 2,
          stringId: 'thead.software',
          defaultString: 'Software',
        }
      )
      numColumns += 1;
    };
    if (checkedHeaders.releaseName) {
      softwareHeaders.push(
        {
          style: 'center',
          stringId: 'thead.releaseType',
          defaultString: 'Release Type',
        }
      )
      numColumns += 1;
    };    
    if (checkedHeaders.release) {
      softwareHeaders.push(
        {
          style: 'center',
          stringId: 'thead.release',
          defaultString: 'Build',
        }
      )
      numColumns += 1;
    };    
    if (checkedHeaders.releaseType) {
      softwareHeaders.push(
        {
          style: 'center',
          stringId: 'thead.releaseReason',
          defaultString: 'Reason',
        }
      )
      numColumns += 1;
    };
    if (checkedHeaders.releaseDate) {
      softwareHeaders.push(
        {
          style: 'center',
          stringId: 'thead.releaseDate',
          defaultString: 'Release Date',
        }
      )
      numColumns += 1;
    };
    if (checkedHeaders.minimumDsmVersionRequired) {
      softwareHeaders.push(
        {
          style: 'center',
          stringId: 'thead.minimumDsmVersionRequired',
          defaultString: 'Minimum DSM Version',
        }
      )
      numColumns += 1;
    };    
    if (checkedHeaders.download) {
      softwareHeaders.push(
        {
          style: 'center',
          stringId: 'thead.download',
          defaultString: 'Download',
        }
      )
      numColumns += 1;
    };
          
    columnWidths = columnDimensions[numColumns - columnOffset] // Select the appropriate column widths from columnDimensions
    patchHeaders = [{ colSpan: columnWidths.length, stringId: 'thead.patch', defaultString: 'Patch' }]; // Match the colSpan to the length of columnWidths

    return (
      <div>
        <section styleName="header">
          <div styleName="title">
            <h3>{product.name}</h3>
          </div>
          <div styleName="select">
            <Select
              options={product.platforms}
              onChange={this.selectPlatform.bind(this)}
              value={platform}
              style={{ display: product.platforms.length > 1 ? 'inline' : 'none' }}
            />
          </div>
          {/* <div
            styleName="versions"
            style={{ display: this.hasMultipleVersions() ? 'block' : 'none' }}
          >
            <a href="javascript:void(0)" onClick={() => this.toggleAllVersions()}>
              {allVersions ? (
                <Translate stringID="link.showLatest" defaultValue="Show Latest Versions" />
              ) : (
                <Translate stringID="link.showAll" defaultValue="Show all Versions" />
              )}
            </a>
          </div> */}
        </section>
        <section style={{ position: 'relative', width: '100%', float: 'left' }}>
          {product.patches.length ? (
            <div styleName="patches-warning">
              <img src={require('images/info.svg')} width={20} height={20} />
              <Translate
                stringID="text.patchesWarning"
                defaultValue="Install patches in order from oldest to newest."
              />
            </div>
          ) : null}
          <Table columnWidths={columnWidths}>
            <TableHeader headers={softwareHeaders} />
            <TableRows
              rowLength={numColumns}
              rows={product.cards}
              fullRelease={fullRelease}
              platform={platform || product.platforms[0].value}
              displayAllVersions={allVersions}
            />
          </Table>
          {product.patches.length ? (
            <Table columnWidths={columnWidths} subTable={true}>
              <TableHeader headers={patchHeaders} />
              <TableRows
                rows={product.patches}
                fullRelease={fullRelease}
                platform={platform || product.platforms[0].value}
                displayAllVersions={true}
              />
            </Table>
          ) : null}
        </section>
      </div>
    );
  }
}

Product.propTypes = {
  product: PropTypes.object.isRequired,
};

export default CSSModules(Product, styles, { allowMultiple: true });
